import {FilterStore} from 'app/store/filters/FilterStore';
import GameInterface from 'app/interfaces/GameInterface';
import {prepareFiltersQuery} from 'app/utils/prepareFiltersQuery';
import {makeObservable, override} from 'mobx';
import getCookies from 'app/utils/getCookies';


export class IncubatorFilterStore extends FilterStore {
    constructor(games: GameInterface[]) {
        super('i', games);
        this.appliedFilters = getCookies(`${this.filterType}Filters`, []);
        makeObservable(this);
    }

    @override
    get queryNavigateParams(): Record<string, string> {
        const filters = prepareFiltersQuery(this.filters);

        return {
            i24h: this.only24h.toString(),
            iDisc: this.discipline,
            iEvent: this.currentEvents,
            iSport: filters,
            iType: this.betType,
            iUp: this.onlyUpcomingMatches.toString()
        };
    }
}

